var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "#221F20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 4L16 2.72972V0H18V4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 22H20V13H22V8.7L11 1L0 8.7V13H2V22H9V18.5688C9 17.4643 9.89543 16.5688 11 16.5688C12.1046 16.5688 13 17.4643 13 18.5688V22ZM20.0001 11H18.0001V20H15.0001V18.5688C15.0001 16.3597 13.2093 14.5688 11.0001 14.5688C8.791 14.5688 7.00014 16.3597 7.00014 18.5688V20H4.00014V11H2.00014V9.74127L11.0001 3.44127L20.0001 9.74127V11Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon-home.a8f1e6fcaa22da2aee152ea16254377d.svg";
export { ForwardRef as ReactComponent };